import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';

const StyledStateIndicator = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    backgroundColor: Palette.white,
    padding: '16px',
    borderRadius: '12px',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
    position: 'relative',
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '-7px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '0',
        height: '0',
        borderLeft: '8px solid transparent',
        borderRight: '8px solid transparent',
        borderTop: `8px solid ${Palette.white}`,
        filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1))',
    },
}));

const StateIndicator = ({ children, sx, ...props }) => {
    return (
        <StyledStateIndicator sx={sx} {...props}>
            {children}
        </StyledStateIndicator>
    );
};

export default StateIndicator;
